"use client"

import { useEffect } from 'react';

// This component is responsible for loading Bootstrap's JavaScript - loaded using a client component so bootstrap JS runs on the client side
function BootstrapClient() {
  useEffect(() => {
    require('bootstrap/dist/js/bootstrap.bundle.min.js');
  }, []);

  return null;
}

export default BootstrapClient;